// src/firebaseConfig.js
import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getAuth } from 'firebase/auth';

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyCbUsTrC3fmMTa197h-eduWwmKW_4zRuPs",
  authDomain: "evergreen-stock-tracker.firebaseapp.com",
  projectId: "evergreen-stock-tracker",
  storageBucket: "evergreen-stock-tracker.firebasestorage.app",
  messagingSenderId: "781169076637",
  appId: "1:781169076637:web:92abe88dceb1d2d6732774"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firestore
const db = getFirestore(app);

export const auth = getAuth(app);

export { db };
